import {connect} from 'react-redux';
import {ActionCreatorsMapObject, bindActionCreators, Dispatch} from 'redux';

import {closeModal} from 'actions/views/modals';

import {IframeModal, Props} from './iframe_modal';

function mapDispatchToProps(dispatch: Dispatch) {
    return {
        actions: bindActionCreators<ActionCreatorsMapObject, Props['actions']>({
            closeModal,
        }, dispatch),
    };
}

export default connect(null, mapDispatchToProps)(IframeModal);
